import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnderwayComponent } from './underway.component';
const routes: Routes = [
  {
    path: '',
    component: UnderwayComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class underwayRoutingoModule { }